export default __webpack_public_path__ + "static/media/01.031a3a82.jpg";